import { TAssetOperationTypeEnum } from '@/shared/hooks/use-assets-app-sync-events/use-assets-app-sync-events.types';
import { gatewaysApi } from '@/shared/redux/api/assets/gateways/gateways-api';
import { useAppDispatch } from '@/shared/redux/hooks/hooks';

export const useInvalidateGatewayTags = () => {
  const dispatch = useAppDispatch();

  const invalidateGatewayTags = (
    gatewayId: string,
    operationType: TAssetOperationTypeEnum,
  ) => {
    switch (operationType) {
      case TAssetOperationTypeEnum.AssetCreated:
      case TAssetOperationTypeEnum.AssetDeleted:
        dispatch(
          gatewaysApi.util.invalidateTags([
            { type: 'Gateway', id: 'LIST' },
            'Groups' as const,
          ]),
        );
        break;
      case TAssetOperationTypeEnum.AssetUpdated:
        dispatch(
          gatewaysApi.util.invalidateTags([
            { type: 'Gateway', id: gatewayId },
            { type: 'Gateway', id: 'LIST' },
            'Groups' as const,
          ]),
        );
        break;
    }
  };

  return {
    invalidateGatewayTags,
  };
};
